import Vue from 'vue';
import router from './router';

import './bootstrap';
import App from './App.vue';

import moment from 'vue-moment';
Vue.use(moment);

import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
    componentPrefix: 'vc',
    locales: {
        'th-TH': {
            firstDayOfWeek: 2,
            masks: {
                L: 'YYYY-MM-DD',
            }
        }
    }
});

import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
Vue.use(VueFileAgent);

//vue cookie : https://www.npmjs.com/package/vue-cookie
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

//vue2-editor
import { Quill } from 'vue2-editor';
import ImageResize from 'quill-image-resize-vue';
Quill.register("modules/imageResize", ImageResize);
//vue2-editor

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

Vue.prototype.$url = (url = null, type = 'url') => {
    switch (type) {
        case 'api':
            return `${process.env.MIX_APP_API}/${url}`;
            break;
        default:
            return `${process.env.MIX_APP_URL}/${url}`;
    }
};

// Vue.config.productionTip = false; false เป็น production ไม่แสดง error npm run production เอาก็ได้

new Vue({
    router,
    ...App
}).$mount('#app');
